import React from "react";
import ReactDOM from "react-dom/client";

// (CSS)
import "./main.css";

// (React router)
import { createBrowserRouter, RouterProvider } from "react-router-dom";

// ( Pages )
import HomePage from "./pages/OldHome";
import WalletPage from "./pages/Wallet";
import SuccessPage from "./pages/Success";
import ConnectPage from "./pages/Connect";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/account",
    element: <WalletPage />,
  },
  {
    path: "/account/connect/:wallet",
    element: <ConnectPage />,
  },
  {
    path: "/success",
    element: <SuccessPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
